<div
  class="group h-full w-full transition-transform duration-300 perspective-distant"
  [class]="{
    'anim-pop-out': state() === 'CORRECT',
    '[animation-delay:500ms]': state() === 'CORRECT',
    'anim-shake': state() === 'INCORRECT',
    'hover:scale-105': isClickable(),
    'hover:rotate-1': isClickable(),
  }"
  (animationend)="$event.animationName === 'shake' || $event.animationName === 'pop-out' ? feedbackAnimEnd.emit() : undefined"
>
  <div
    class="relative h-full w-full transition-transform duration-500 transform-3d"
    [class.rotate-y-180]="state() !== 'HIDDEN'"
    [class.cursor-pointer]="isClickable()"
    [attr.role]="isClickable() ? 'button' : null"
    [attr.tabindex]="isClickable() ? 0 : null"
    (click)="isClickable() ? clicked.emit() : undefined"
    (keydown.enter)="isClickable() ? clicked.emit() : undefined"
    (keydown.space)="$event.preventDefault(); isClickable() ? clicked.emit() : undefined"
  >
    <div class="absolute inset-0 grid place-items-center rounded-xl bg-emerald-500 p-1 transition-colors backface-hidden">
      <div class="h-full w-full rounded-lg bg-emerald-300"></div>
    </div>

    <div class="absolute inset-0 grid rotate-y-180 place-items-center transition-colors backface-hidden">
      <rid-content-card
        #contentCard
        class="h-full w-full"
        [fullWidth]="true"
        [fullHeight]="true"
        [autoSizeText]="true"
        [text]="text()"
        [image]="image()"
        [audio]="audio()"
        [state]="contentCardState()"
        [isClickable]="isClickable()"
      />
    </div>
  </div>
</div>
